import { makeStyles } from "tss-react/mui";
import { Box, Typography } from "@mui/material";
import { MiIcon } from "../MiIcon/MiIcon";

export const MiSection = ({
  children,
  headerTitle,
  headerIcon,
  headerIconColor,
  hideShadow = false,
}: {
  children: React.ReactNode;
  headerTitle?: string;
  headerIcon?: string;
  headerIconColor?: string;
  hideShadow?: boolean;
}) => {
  const { classes } = useStyles({ hideShadow });
  return (
    <Box className={classes.sectionContainer}>
      {headerTitle && (
        <Box className={classes.sectionHeader}>
          {headerIcon && <MiIcon path={headerIcon} color={headerIconColor} />}
          {headerTitle && <Typography variant="HD3">{headerTitle}</Typography>}
        </Box>
      )}
      {children}
    </Box>
  );
};

const useStyles = makeStyles<{ hideShadow: boolean }>()(
  (theme, { hideShadow }) => ({
    sectionContainer: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(4),
      padding: theme.spacing(3),
      backgroundColor: theme.palette.grey[50],
      borderRadius: theme.shape.borderRadius,
      boxShadow: !hideShadow ? theme.shadows[1] : "none",
    },
    sectionHeader: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1),
    },
  })
);
